import React from "react";
import { Modal } from "react-bootstrap";
import { FaEye, FaUserSlash, FaUsers, FaDesktop } from "react-icons/fa";

function ViolationModal({ show, onHide, violation }) {
  const getViolationConfig = (type) => {
    switch (type) {
      case 'eyes-off-target':
        return {
          icon: <FaEye style={{ fontSize: 60, color: '#fff' }} />,
          title: 'Attention Required',
          message: 'Eye movement detected. Please keep your eyes on the screen',
        };
      case 'head-off-screen':
        return {
          icon: <FaUserSlash style={{ fontSize: 60, color: '#fff' }} />,
          title: 'Head Position Alert',
          message: 'Your head is not visible. Please adjust your position',
        };
      case 'no-face':
        return {
          icon: <FaUserSlash style={{ fontSize: 60, color: '#fff' }} />,
          title: 'Face Not Detected',
          message: 'Please position yourself in front of the camera',
        };
      case 'multiple-faces':
        return {
          icon: <FaUsers style={{ fontSize: 60, color: '#fff' }} />,
          title: 'Multiple People Detected',
          message: 'Only you should be visible during the assessment',
        };
      case 'tab-switched':
      case 'tab-hidden':
        return {
          icon: <FaDesktop style={{ fontSize: 60, color: '#fff' }} />,
          title: 'Tab Switch Detected',
          message: 'Please keep this tab in focus during the assessment. Switching tabs is not allowed.',
        };
      default:
        return {
          icon: <FaEye style={{ fontSize: 60, color: '#fff' }} />,
          title: 'Attention Required',
          message: 'Please follow the proctoring guidelines',
        };
    }
  };

  const config = violation ? getViolationConfig(violation.type) : null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="violation-modal"
    >
      <div style={{
        position: 'relative',
        borderRadius: 12,
        overflow: 'hidden',
        border: 'none',
      }}>
        {/* Yellow Header with Wave */}
        <div style={{
          background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
          padding: '40px 20px 60px',
          position: 'relative',
          textAlign: 'center',
        }}>
          {/* Icon */}
          {config?.icon}
          
          {/* Wave Shape */}
          <svg
            style={{
              position: 'absolute',
              bottom: -1,
              left: 0,
              width: '100%',
              height: 40,
            }}
            viewBox="0 0 500 40"
            preserveAspectRatio="none"
          >
            <path
              d="M0,20 Q125,0 250,20 T500,20 L500,40 L0,40 Z"
              fill="#ffffff"
            />
          </svg>
        </div>

        {/* Content Area */}
        <div style={{
          background: '#fff',
          padding: '30px 40px 40px',
          textAlign: 'center',
        }}>
          {/* Title */}
          <h4 style={{
            fontSize: 24,
            fontWeight: 700,
            marginBottom: 16,
            color: '#1f2937',
          }}>
            {config?.title}
          </h4>

          {/* Message */}
          <p style={{
            fontSize: 15,
            color: '#6b7280',
            marginBottom: 32,
            lineHeight: 1.6,
          }}>
            {config?.message}
          </p>

          {/* Buttons */}
          <div style={{
            display: 'flex',
            gap: 12,
            justifyContent: 'center',
          }}>
            <button
              onClick={onHide}
              style={{
                padding: '12px 32px',
                fontSize: 15,
                fontWeight: 600,
                background: '#3b82f6',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                transition: 'all 0.2s',
                minWidth: 100,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#2563eb';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#3b82f6';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Close
            </button>
            <button
              onClick={onHide}
              style={{
                padding: '12px 32px',
                fontSize: 15,
                fontWeight: 600,
                background: '#3b82f6',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                transition: 'all 0.2s',
                minWidth: 100,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#2563eb';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#3b82f6';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Got it
            </button>
          </div>
        </div>
      </div>

      {/* Custom CSS for modal */}
      <style>{`
        .violation-modal {
          border: none;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          border-radius: 12px;
        }
        .violation-modal .modal-content {
          border: none;
          border-radius: 12px;
        }
      `}</style>
    </Modal>
  );
}

export default ViolationModal;


